exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".settings {\r\n\tposition: absolute;\r\n\ttop: 1rem;\r\n\tleft: 1rem;\r\n}\r\n", ""]);
